<script lang="ts">
  import QuestionText1 from "./QuestionText.svelte";

  export let word: string
</script>

<div style="text-align: center;">
  <QuestionText1 {word} />
</div>